import React, { useEffect, useState } from "react";
import "./facilitiescard.css";
import { AnimatePresence, motion, useAnimation } from "motion/react";
import { useInView } from "react-intersection-observer";

const FacilitiesCard = ({ url, title, index, size }) => {
  const [mouseOverIndex, setMouseOverIndex] = useState(null);

  const variants = {
    initial: { opacity: 0, y: -100 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -100 },
  };

  const isEven = (value) => {
    return Number(value) % 2 == 0;
  };

  return (
    <motion.div
      className={`w-full h-[400px] border facilities-card p-4 `}
      initial={isEven(index) ? { opacity: 0, x: -100 } : { opacity: 0, x: 100 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: false, amount: 0.5 }}
      onMouseOver={() => setMouseOverIndex(index)}
      onMouseOut={() => setMouseOverIndex(null)}
    >
      <img className="w-full h-[380px] object-contain" src={url} />
      <AnimatePresence>
        {mouseOverIndex == index && (
          <motion.h3
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            {title} : {size}
          </motion.h3>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default FacilitiesCard;
